import { LANDLORDS_URL } from '../constants'; // Define the base URL for landlords API
import { apiSlice } from './apiSlice';

export const landlordsApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // Fetch all landlords with filtering and pagination
    getLandlords: builder.query({
      query: ({ keyword = '', pageNumber = 1 }) => ({
        url: LANDLORDS_URL,
        params: { keyword, pageNumber }, // Enable filtering and pagination
      }),
      keepUnusedDataFor: 5, // Cache unused data for 5 seconds
      providesTags: ['Landlords'], // Tag used for cache invalidation
    }),

    // Fetch a single landlord by ID
    getLandlordDetails: builder.query({
      query: (landlordId) => ({
        url: `${LANDLORDS_URL}/${landlordId}`,
      }),
      keepUnusedDataFor: 5, // Cache unused data for quick access
    }),

    // Create a new landlord
    createLandlord: builder.mutation({
      query: (data) => ({
        url: LANDLORDS_URL,
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['Landlords'], // Refresh landlord list cache
    }),

    // Update an existing landlord by ID
    updateLandlord: builder.mutation({
      query: (data) => ({
        url: `${LANDLORDS_URL}/${data.landlordId}`,
        method: 'PUT',
        body: data,
      }),
      invalidatesTags: ['Landlords'], // Refresh landlord list after update
    }),

    // Delete a landlord by ID
    deleteLandlord: builder.mutation({
      query: (landlordId) => ({
        url: `${LANDLORDS_URL}/${landlordId}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Landlords'], // Refresh landlord list cache
    }),

    // Fetch top landlords (based on specific criteria such as sales)
    getTopLandlords: builder.query({
      query: () => `${LANDLORDS_URL}/top`,
      keepUnusedDataFor: 5, // Cache unused data for quick access
    }),
  }),
});

export const {
  useGetLandlordsQuery, // Hook to fetch all landlords
  useGetLandlordDetailsQuery, // Hook to fetch details of a specific landlord
  useCreateLandlordMutation, // Hook to create a landlord
  useUpdateLandlordMutation, // Hook to update a landlord
  useDeleteLandlordMutation, // Hook to delete a landlord
  useGetTopLandlordsQuery, // Hook to fetch top landlords
} = landlordsApiSlice;